import classNames from 'classnames';
import { useSwiper } from 'swiper/react';
import ContentNavigation from '@/components/molecules/content-navigation/content-navigation';
import styles from './header-carousel-navigation.module.scss';

export interface HeaderCarouselNavigationProps {
  /** The class name to apply */
  className?: string;
  /** The current index */
  currentIndex?: number;
  /** Indicates whether autoplay is active */
  isPlaying?: boolean;
  /** An event that gets triggered when pausing */
  onPause?: () => void;
  /** An event that gets triggered when playing */
  onPlay?: () => void;
  /** The total page count */
  pageCount?: number;
}

const HeaderCarouselNavigation = ({
  className,
  currentIndex,
  isPlaying = false,
  onPause,
  onPlay,
  pageCount,
}: HeaderCarouselNavigationProps) => {
  const swiper = useSwiper();

  const handleTogglePlay = () => {
    if (isPlaying) {
      swiper.autoplay.pause();
      onPause?.();
    } else {
      swiper.autoplay.start();
      onPlay?.();
    }
  };

  const handleClickNext = () => {
    swiper.autoplay.pause();
    onPause?.();
    swiper.slideNext();
  };

  const handleClickPrevious = () => {
    swiper.autoplay.pause();
    onPause?.();
    swiper.slidePrev();
  };

  return (
    <div className={classNames(styles.component, className)}>
      <ContentNavigation
        className={styles.navigation}
        currentIndex={currentIndex}
        isPlaying={isPlaying}
        onClickNext={handleClickNext}
        onClickPrevious={handleClickPrevious}
        onTogglePlay={handleTogglePlay}
        pageCount={pageCount}
      />
    </div>
  );
};

HeaderCarouselNavigation.displayName = 'HeaderCarouselNavigation';

export default HeaderCarouselNavigation;
